import React, { useState } from "react";
import PropTypes from "prop-types";
import TableComponent from "../../../../components/coreUiTable/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../../utils/xlsxExport";
import { cuFormat } from "../../../../components/coreUiTable/Format";

const Table = ({ data, colHeaders, xlsxFileName = "download", columns }) => {
  let [filteredData, setFilteredData] = useState([]);
  const onFilteredItemsChange = (data) => {
    setFilteredData(data);
  };

  const formattedSlots = cuFormat({
    headers: colHeaders,
    columns: columns
  });

  return (
    <div className="content">
      {data.length > 0 ? (
        <TableComponent
          table={{ data, colHeaders }}
          sorter
          itemsPerPage={15}
          title=" "
          onFilteredItemsChange={onFilteredItemsChange}
          overTableSlots={
            <div className="content_download">
              {filteredData.length > 0 ? (
                <a
                  title="Export to Excel"
                  /*download={`${csvFileName}.csv`} href={csvContent(headers, filteredData)}*/ onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      fileName: xlsxFileName,
                      dataStructure: "jts"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} />
                </a>
              ) : (
                <FontAwesomeIcon icon={faDownload} disabled />
              )}
            </div>
          }
          scopedSlots={{
            ["Days Since Last Login"]: (item) => (
              <td>
                {item["Days Since Last Login"] === 0 ? "today" : item["Days Since Last Login"]}
              </td>
            ),
            ...formattedSlots
          }}
        />
      ) : (
        <div className="content__error error">No data for this table</div>
      )}
    </div>
  );
};
Table.propTypes = {
  data: PropTypes.array,
  colHeaders: PropTypes.arrayOf(PropTypes.string),
  xlsxFileName: PropTypes.string
};
export default Table;
